import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, ShieldIcon } from './Icons';
export function FinalOffer() {
  return <section id="oferta" className="w-full bg-white-soft py-10 md:py-24 px-5" data-id="element-202">
      <div className="max-w-2xl mx-auto" data-id="element-203">
        {/* Closing Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-204">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-brown-dark mb-6" data-id="element-205">
            Todo. Por una sola inversión de $17 USD.
          </h2>
          <div className="space-y-4 font-body text-lg text-brown-medium leading-relaxed" data-id="element-206">
            <p className="font-semibold text-brown-dark" data-id="element-207">
              Sin suscripciones. Sin pagos recurrentes. Sin esperas.
            </p>
            <p data-id="element-208">
              Descargas todo al instante, en tu celular o tablet, y puedes
              empezar hoy mismo.
            </p>
            <p className="mt-8 italic" data-id="element-209">
              Mientras el cuero cabelludo siga picando, mientras el cepillo siga
              llenándose, mientras sigas mirando la almohada con ese nudo en el
              estómago…
            </p>
            <p className="font-semibold text-brown-dark" data-id="element-210">
              el problema no se va solo.
            </p>
            <p className="mt-6 font-bold text-xl text-sage-dark" data-id="element-211">
              Pero la solución está aquí. Simple, clara y lista para ti.
            </p>
          </div>
        </motion.div>

        {/* Pre-CTA Comparison */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-12 md:mb-16" data-id="element-212">
          <h3 className="font-heading text-2xl font-bold text-brown-dark text-center mb-8" data-id="element-213">
            ¿Qué prefieres?
          </h3>

          <div className="space-y-4" data-id="element-214">
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-215">
              <p className="font-body text-base text-warm-gray" data-id="element-216">
                Seguir probando champús que no funcionan, gastando $20, $30, $50
                en productos que no entienden tu cuero cabelludo…
              </p>
            </div>

            <div className="bg-gold/10 rounded-xl p-6 border-2 border-gold shadow-md" data-id="element-217">
              <p className="font-body text-lg font-bold text-brown-dark" data-id="element-218">
                …o invertir $17 una sola vez y tener el protocolo completo, los
                3 bonos, y el plan exacto para empezar hoy.
              </p>
            </div>
          </div>

          <p className="font-heading text-xl font-bold text-brown-dark text-center mt-8 italic" data-id="element-219">
            La respuesta ya la sabes.
          </p>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-220">
          <a href="https://rutinasimple.com//cart/52144851714329:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'AddToCart', {
              content_name: 'Rescate Capilar 60+',
              content_type: 'product',
              value: 17,
              currency: 'USD'
            });
          }
        }} className="inline-flex flex-col items-center justify-center gap-2 bg-gold text-white px-6 py-5 md:px-10 md:py-6 rounded-2xl shadow-xl shadow-gold/30 hover:bg-gold-light hover:shadow-2xl hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-white-soft w-full" aria-label="Comprar el Protocolo y Bonos" data-id="element-221">
            <span className="flex items-center gap-3 font-heading font-bold text-lg md:text-xl text-center" data-id="element-222">
              <DownloadIcon className="w-6 h-6 flex-shrink-0" data-id="element-223" />
              SÍ, QUIERO MI PROTOCOLO COMPLETO + LOS 3 BONOS GRATIS
            </span>
            <span className="font-body text-sm md:text-base font-medium opacity-90" data-id="element-224">
              Acceso inmediato · PDF · Solo $17 USD
            </span>
          </a>
          <p className="font-body text-sm text-warm-gray mt-4 flex items-center justify-center gap-2" data-id="element-225">
            <ShieldIcon className="w-4 h-4 text-sage" data-id="element-226" />
            (Pago seguro · Descarga al instante · Sin suscripciones)
          </p>
        </motion.div>

        {/* Post-CTA Urgency */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="bg-cream rounded-xl p-6 md:p-8 border border-gold/20 text-center mb-16" data-id="element-227">
          <p className="font-body text-base text-brown-medium leading-relaxed mb-4" data-id="element-228">
            Los bonos están disponibles hoy con tu compra. No hay fecha de
            cierre artificial ni cuenta regresiva falsa. Pero sí hay esto:
          </p>
          <p className="font-body text-lg font-semibold text-brown-dark leading-relaxed mb-4" data-id="element-229">
            Cada día que pasa sin un plan claro, es un día más de picor, un día
            más de caída, un día más de mirar el cepillo con miedo.
          </p>
          <p className="font-heading text-xl font-bold text-gold" data-id="element-230">
            Hoy puedes cambiar eso. Por $17.
          </p>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="bg-sage-light/30 rounded-2xl p-8 md:p-10 border-2 border-sage/30 text-center mb-16 relative overflow-hidden" data-id="element-231">
          <div className="absolute top-0 left-0 w-full h-2 bg-sage" data-id="element-232" />
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-sage/10 mb-6" data-id="element-233">
            <ShieldIcon className="w-8 h-8 text-sage" data-id="element-234" />
          </div>
          <h3 className="font-heading text-2xl font-bold text-brown-dark mb-4" data-id="element-235">
            Sin riesgo. Sin letra chica.
          </h3>
          <div className="space-y-4 font-body text-base md:text-lg text-brown-medium leading-relaxed" data-id="element-236">
            <p data-id="element-237">
              Si en los próximos 30 días sientes que el material no era lo que
              esperabas, escríbenos y te devolvemos cada centavo.
            </p>
            <p data-id="element-238">Sin preguntas. Sin formularios complicados. Sin drama.</p>
            <p className="font-bold text-sage-dark text-xl mt-6" data-id="element-239">
              El riesgo es nuestro, no tuyo.
            </p>
          </div>
        </motion.div>

        {/* Final CTA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-240">
          <a href="#oferta" className="inline-flex flex-col items-center justify-center gap-2 bg-gold text-white px-6 py-5 md:px-10 md:py-6 rounded-2xl shadow-xl shadow-gold/30 hover:bg-gold-light hover:shadow-2xl hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-white-soft w-full" aria-label="Comprar el Protocolo y Bonos Ahora" data-id="element-241">
            <span className="flex items-center gap-3 font-heading font-bold text-lg md:text-xl text-center" data-id="element-242">
              <DownloadIcon className="w-6 h-6 flex-shrink-0" data-id="element-243" />
              QUIERO EL PROTOCOLO + MIS 3 BONOS GRATIS AHORA
            </span>
            <span className="font-body text-sm md:text-base font-medium opacity-90" data-id="element-244">
              Acceso inmediato · PDF · Solo $17 USD
            </span>
          </a>
          <p className="font-body text-sm text-warm-gray mt-4 flex items-center justify-center gap-2" data-id="element-245">
            <ShieldIcon className="w-4 h-4 text-sage" data-id="element-246" />
            (Pago seguro · Descarga al instante · Sin suscripciones)
          </p>
        </motion.div>
      </div>
    </section>;
}